"use client";

import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { useGLTF } from "@react-three/drei";
import { Suspense } from "react";

function HeadModel({ modelPath }) {
  const { scene } = useGLTF(modelPath);

  return (
    <div>
      <Canvas camera={{ position: [40, 10, 50] }} style={{ width: "100vw", height: "100vh" }}>
        <Suspense fallback={null}>
            <ambientLight intensity={1} />
            <directionalLight position={[2, 2, 2]} intensity={10} />
            <primitive object={scene} scale={0.5} />
            <OrbitControls enableZoom={false} />
        </Suspense>
      </Canvas>
    </div>
  );
}

export default HeadModel;